import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import CodLeftPanel from "../include/CodLeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useParams,useLocation } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";
import AuthUser from "../../AuthUser";
import ListLoader from "../Loaders/ListLoader";
import CopyToClipboard from 'react-copy-to-clipboard';
import { Modal,Button } from 'react-bootstrap';


const DriverCodOverview = () => {
    let navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [filter, setFilter] = useState("all");
  const location = useLocation();
      const{headers1,headers2,logout}=AuthUser();
      const {type} = useParams();
      const [list, setList] = useState([]);
      const [Loading, setLoading] = useState(false);
      const [Subloading, setSubloading] = useState(false);
      const [SearchVal, setSearchVal] = useState('');
      const [Searchstartdate, setSearchstartdate] = useState('');
      const [Searchenddate, setSearchenddate] = useState('');
      const [currentPage, setCurrentPage] = useState(1);
      const [lastPage, setLastPage] = useState(1); // Total number of pages
      const [nextPageUrl, setNextPageUrl] = useState(null);
      const [prevPageUrl, setPrevPageUrl] = useState(null);
      const pageRangeDisplayed = 2; 
      const [startdate, setStartdate] = useState(getTodayDateString());
      const [enddate, setEnddate] = useState(getTodayDateString());
      const [showModal, setShowModal] = useState(false);
      const [showsummaryModal, setShowsummaryModal] = useState(false);
      const [selectedDriver, setSelectedDriver] = useState(null);
      const items = JSON.parse(localStorage.getItem('user'));
      

  useEffect(()=>{
          const query = new URLSearchParams(location.search);
          const page = query.get('page') ? parseInt(query.get('page'), 10) : 1;
          const search = query.get('search') || '';
          const startdate = query.get('startdate') || '';
          const enddate = query.get('enddate') || '';
          setCurrentPage(page);
          setSearchVal(search);
          setSearchstartdate(startdate);
          setSearchenddate(enddate);
          GetCustomerList(page,startdate,enddate,search);
      },[location.search]);


 const GetCustomerList=(page=1,startdate,enddate,val)=>{
        setSubloading(true);
        axios({
            method: 'post',
            url: Global.baseUrl+'FetchDriverCodHistory',
            headers:headers1,
            data: {
                usertype:items.usertype,
                hubid:items.id,
                searchstartdate:startdate,
                searchenddate:enddate,
                page:page
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value.data;
                setList(data);
                setCurrentPage(response.data.value.current_page);
                setLastPage(response.data.value.last_page);
                setNextPageUrl(response.data.value.next_page_url); // URL for next page
                setPrevPageUrl(response.data.value.prev_page_url); // URL for previous page
            }
            else
            {
                setList();
            }
            setSubloading(false);
            setLoading(false);
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                // logout();
                // navigate('/');
                // window.location.reload();
            }
            setSubloading(false);
            setLoading(false);
            // console.log(error);
          });
    }

  // Function to get today's date in the format "YYYY-MM-DD"
    function getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

     // Update the URL and fetch the data for the selected page
 const handlePageChange = (pageNumber) => {
    const query = new URLSearchParams(location.search);
    query.set('page', pageNumber);
    navigate(`?${query.toString()}`);
  };


  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const query = new URLSearchParams(location.search);
    query.set('search', SearchVal);
    query.set('startdate', startdate);
    query.set('enddate', enddate);
    query.set('page', 1); // Reset to page 1 on a new search
    navigate(`?${query.toString()}`);
  };
  // Handle Previous button click
  const handlePreviousPage = () => {
    if (prevPageUrl) {
      handlePageChange(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNextPage = () => {
    if (nextPageUrl) {
      handlePageChange(currentPage + 1);
    }
  };

// Create pagination items for each page, showing a limited number of page numbers with ellipses
const renderPageNumbers = () => {
    const pages = [];

    // Always show the first page
    if (currentPage > pageRangeDisplayed + 1) {
      pages.push(
        <li key={1} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
        </li>
      );
      pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
    }

    // Show the range of pages around the current page
    for (let i = Math.max(1, currentPage - pageRangeDisplayed); i <= Math.min(lastPage, currentPage + pageRangeDisplayed); i++) {
      pages.push(
        <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    // Always show the last page
    if (currentPage < lastPage - pageRangeDisplayed) {
      pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
      pages.push(
        <li key={lastPage} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(lastPage)}>{lastPage}</button>
        </li>
      );
    }

    return pages;
  };
  const handleModel = (cust) => {
  setSelectedDriver(cust);
  setShowModal(true);
};
  const handleClose = () => setShowModal(false); // Close modal handler

  return (
    <>
    <CodLeftPanel/>
    <main className='home-section'>
        <Header/>
        <ToastContainer/>
         {Loading==true?<MainLoader/>:
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <Link to={`/Admin-Dash`}>
                                    <i className="bx bx-home text-primary-400 fs-6"></i>
                                </Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Driver COD</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={()=>navigate(-1)}>
                                <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">All Drivers COD</h2>
                        </div>
                    </div>
                </div>
                
            </div>

            {/* show Help model */}

            <div className="row">
                <div className="col-12 col-md-6"></div>
                <div className="col-12 col-md-6">
                    <div className="table-settings shipment_list" id="">
                        <div className="row align-items-start g-2" >
                            <div className="col col-md-12">
                            <form onSubmit={handleSearchSubmit}>
                                    <div className="input-group ">
                                        <div className="col-12 col-md-5 mb-3">
                                            <div><label htmlFor="email" className="form-label">From Date: <span className="text-danger"></span></label></div>
                                            <input type="date" className="form-control" id="text" value={startdate} placeholder="Enter city name" onChange={(e)=>setStartdate(e.target.value)}/>
                                        </div>
                                        <div className="col-12 col-md-5 mb-3">
                                            <div><label htmlFor="email" className="form-label">To Date: <span className="text-danger"></span></label></div>
                                            <input type="date" className="form-control" id="text" value={enddate} placeholder="Enter city name" onChange={(e)=>setEnddate(e.target.value)}/>
                                        </div>
                                        <div className="col-12 col-md-2 mb-3">
                                          <div><label htmlFor="email" className="form-label"><span className="text-danger"></span></label></div>
                                          <button type="submit" className="input-group-text btn-lg mt-2">
                                              <i className="bx bx-search"></i>
                                          </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="data_table">
                <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                    
                    <table className="table table-hover">
                        <thead>
                        
                            <tr>
                                <th className="border-gray-200">Driver Code</th>
                                <th className="border-gray-200">Driver Name </th>
                                <th className="border-gray-200">Total Shipment</th>
                                <th className="border-gray-200">Total COD Pay</th>
                                <th className="border-gray-200">Date / Time</th>
                            </tr>
                        </thead>
                        {Subloading==true && <ListLoader/>}
                        {list!=undefined && Subloading==false ?
                        <tbody>
                            {list.map((dri,index)=>{
                                return(
                                <tr key={index}>
                                    <td>
                                        <div>
                                            {dri.messenger_code}
                                            <CopyToClipboard text={dri.messenger_code} onCopy={()=>{toast.success(dri.messenger_code+' Copied To Clipboard')}}>
                                                <i className="bx bx-copy"></i>
                                            </CopyToClipboard>
                                        </div>
                                    </td>
                                    <td><span className="fw-normal text-capitalize">{dri.messenger_name}</span></td>
                                    <td><span className="fw-normal text-capitalize"><a onClick={() => handleModel(dri.awbno)}>{dri.total_Shipment_count}</a></span></td>
                                    <td><span className="fw-normal text-capitalize">{parseFloat(dri.total_amount).toFixed(2)}</span></td>
                                    <td><span className="fw-normal text-capitalize">{dri.date} {dri.time}</span></td>
                                    
                                </tr>
                            )})}                 
                        </tbody>
                        :
                        <tbody><tr><td colSpan={8}>Record Not Found</td></tr></tbody>
                        }
                    </table>
                    
                    
                </div>
            </section>
            <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                <nav aria-label="Page navigation example">
                    <ul className="pagination mb-0">
                    {/* Previous Button */}
                    <li className={`page-item ${!prevPageUrl ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={handlePreviousPage} disabled={!prevPageUrl}>
                        Previous
                        </button>
                    </li>

                    {/* Page Numbers */}
                    {renderPageNumbers()}

                    {/* Next Button */}
                    <li className={`page-item ${!nextPageUrl ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={handleNextPage} disabled={!nextPageUrl}>
                        Next
                        </button>
                    </li>
                    </ul>
                </nav>
                {/* <div className="fw-normal small mt-4 mt-lg-0">Showing <b>5</b> out of <b>25</b> entries</div> */}
            </div>
            </>
        }
        <Footer/>
    </main>
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Shipments</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-info text-center">
          <h3>AWB Number</h3>
        </div>
        <div className="row mt-3">
          <div className="col-12 col-md">
            <div className="row">
              <div className="col-12 col-md-12 mb-3 text-center">
                <table className="table table-bordered">
                  <thead>
                    <th>AWB No.</th>
                    <th>Total Amount</th>
                  </thead>
                  <tbody>
                  {selectedDriver?.length > 0 ? (
                      selectedDriver.map((sno, i) => (
                        <tr key={i}>
                          <td>{sno.shipment_id}</td>
                          <td>{sno.amount}</td>
                        </tr>
                      ))
                    ) : (
                      <div>No data available</div>
                    )}
                  </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default DriverCodOverview;
